module.exports = __webpack_public_path__ + "img/04.870d1e02.jpg";